import * as header from './a11y-header.js';
import * as footer from './a11y-footer.js';
import * as SkipLink from './a11y-skip_link.js';
import * as projectWide from './a11y-project_wide.js';
import * as homePage from './a11y-home_page.js';
import * as productDetails from './a11y-product_details_page.js';
import * as addToCart from './a11y-add_to_cart_page.js';
import * as yourCart from './a11y-your_cart_page.js';
import * as signIn from './a11y-sign_in_page.js';
import * as aboutUs from './a11y-about_us_page.js';
import * as puppetsCollection from './a11y-finger_puppets_collection.js';
import Announcements from './a11y-announcements.js';

document.addEventListener("readystatechange", (event) =>
{
    if(event.target.readyState === "interactive")
    {

    }
    if(event.target.readyState === "complete")
    {
        console.log("Page load complete!")
        //To create and render announcement element container
        Announcements.createAccessibleElements();
        SkipLink.renderSkipLink();
        SkipLink.renderSkipInstagramLink();
        header.subjectCategoriesLinks();
        header.getLogoAltText();
        header.getOutlineOnTopHeaderLink();
        header.hideSearchButton();
        header.accessibleSearchBar();
        header.setInnerTextToSocialMediaIcons();
        header.setVariousNavbars();
        //This will reduce the width of search bar when focus out from it.
        header.showContactMenu();
        //To announce "No result found message"
        header.searchBarAnnoucement();
        //To show hamburgerMenu at 200% zoom
        header.handleHamburgerMenuVisibility();
        //To make main navigation menubar keyboard accessible
        header.getAccessibleMenubar();
        
        footer.hideEinsteinImage();

        //Hide mailing list popup from screen reader and keyboard users as it is not displayed visually!
        projectWide.hideMailingListPopup();
        /* 
        * This fixes following issues:
          * - Role issues of tab.
          * - selected state of tab
          * - keyboard operability in the tab
        */
        homePage.tabFixes();
        //To fix redundant links
        homePage.fixRedundantLinks();
        // To hide/unhide slides from keyboard and SR users
        homePage.manageCarouselSlides();
        //To fix role and descriptive label related issues for carousel nav buttons.
        homePage.manageCarouselNavButtons();
        //To remove unwanted heading markups on home page
        homePage.removeHeadingMarkup();
        //To add descriptive labels to the dots ofTESTIMONIALS carousel.
        homePage.addDescriptiveLabel();
        //To add heading markup for "On instagram:" text.
        homePage.addHeadingMarkup();
        //Wrapping div inside li to fix direct child issue
        homePage.wrapElement();
        //To show carousel and tabs on 320px page width
        homePage.handleCarouselWindowResize();
        //To add label to the quantity field.
        productDetails.addLabelAndRole();
        //To add label to the "X" link.
        productDetails.addLinkText();
        //To fix heading structure related issues
        productDetails.fixHeadingMarkup();
        //Fix list markup related issues
        productDetails.removeListMarkup();
        //To set inner text for icons
        productDetails.setInnerTextToSocialMediaIcons();
        //To fix heading related issues of "Add to cart" page
        addToCart.manageHeadings();
        //Add list markup
        addToCart.addListMarkup();
        //set alt text on added to cart image
        addToCart.setAltToProductImage();
        //Add row headers to the table
        yourCart.addRowHeaders();
        /*
        * added following fixes:
        ** keyboard support for quantity buttons.
        ** labels of quantity buttons.
        ** announcement of current quantity when updated.
        ** label for "update" link when the quantity is updated.
        */
        yourCart.addKeyboardSupportAndLabelForQuantity();
        //Uniqe id fix
        yourCart.uniqueIDFix();
        //Add required attribute to the input fields.
        signIn.makeFieldRequired();
        //Add autocomplete attribute to the form fields
        signIn.addAutoComplete();
        //Add announcement to the error messages
        signIn.errorAnnouncement();
        //Fix page title issue for Sign in and reset password page.
        signIn.fixPageTitle();
        //Fix heading markup issue for about us page.
        aboutUs.fixHeadingMarkup();
        //Remove unwanted role option from the testimonial carousel.
        homePage.removeRoleOption();
        //Add unique label to multiple links.
        puppetsCollection.addUniqueLabelToLinks();
        //live announcement after adding a product to the cart.
        productDetails.announceStatusMessage();
        //add unique label to multiple buttons.
        puppetsCollection.addUniqueLabelToButtons();
        //Fix issues of instagram carousels
        setTimeout(function() {
          homePage.manageInstaSlides();
        }, 4000);
        
        //Unique id fix
        puppetsCollection.uniqueIDFix();
        //Fix keyboard support for the carousels.
        homePage.addKeyboardSupportForCarouselNavButtons("#horizontalTab-1 > div");
        homePage.keyboardSupportForSecondCarousel();
    }
  });
